<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'zyForm',
})
</script>
<template>
	<el-dialog
		v-if="isShow"
		v-model="isShow"
		class="deep-blue-theme deep-blue-theme-dialog zy"
		append-to-body
		:title="dialog.title"
		:width="props.width"
		top="8vh"
		size="mini"
		:close-on-click-modal="false"
	>
		<el-form
			ref="form"
			style="display: flex; flex-wrap: wrap; max-height: 70vh; padding-right: 15px; overflow-y: auto"
			:label-width="dialog?.labelWidth ?? '80px'"
			:model="dialog.form"
			:rules="rules"
		>
			<el-form-item
				v-for="item in dialog.config"
				v-show="(item.show !== undefined ? item.show() : true) && !item.group"
				:key="item.name"
				class="item"
				:prop="item.name"
				:label="item.label"
			>
				<ma-org-inspect-select
					v-if="item.type === 'orgBiz'"
					v-model="dialog.form[item.name]"
					:placeholder="item.placeholder"
					:clearable="item.clearable"
					:disabled="item.disable === undefined ? false : item.disable()"
					:check-strictly="true"
					@change="handleChange(item)"
				></ma-org-inspect-select>
				<el-input
					v-if="item.type === 'input'"
					v-model="dialog.form[item.name]"
					class="item1"
					:placeholder="item.placeholder"
					:disabled="item.disable === undefined ? false : item.disable()"
					@change="handleChange(item)"
				></el-input>
				<el-input
					v-if="item.type === 'textarea'"
					v-model="dialog.form[item.name]"
					class="item1"
					type="textarea"
					:rows="item?.rows ?? 2"
					:placeholder="item.placeholder"
					:disabled="item.disable === undefined ? false : item.disable()"
					@change="handleChange(item)"
				></el-input>
				<el-input-number
					v-if="item.type === 'number'"
					v-model="dialog.form[item.name]"
					class="item1"
					:min="item?.min ?? -Infinity"
					:max="item?.max ?? Infinity"
					:placeholder="item.placeholder"
					@change="handleChange(item)"
				></el-input-number>
				<el-switch
					v-if="item.type === 'switch'"
					v-model="dialog.form[item.name]"
					class="item1"
					:active-text="item?.options?.active?.text ?? ''"
					:inactive-text="item?.options?.inactive?.text ?? ''"
					:active-value="item?.options?.active?.value ?? ''"
					:inactive-value="item?.options?.inactive?.value ?? ''"
					@change="handleChange(item)"
				></el-switch>
				<el-checkbox
					v-if="item.type === 'checkbox'"
					v-model="dialog.form[item.name]"
					class="item1"
					:disabled="item.disable === undefined ? false : item.disable()"
					@change="handleChange(item)"
				></el-checkbox>
				<div v-if="item.type === 'checkbox_row'" class="item1">
					<el-checkbox
						v-for="opt in item.options"
						:key="opt.value"
						v-model="dialog.form[opt.value]"
						:disabled="item.disable === undefined ? false : item.disable()"
						@change="handleChange(item)"
					>
						{{ opt.label }}
					</el-checkbox>
				</div>
				<el-cascader
					v-if="item.type === 'cascader'"
					v-model="dialog.form[item.name]"
					class="item1"
					:placeholder="item.placeholder"
					:options="item.options"
					:show-all-levels="item?.showAllLevels ?? false"
					:props="{ checkStrictly: item?.checkStrictly ?? true, multiple: item?.multiple ?? false }"
					clearable
					@change="handleChange(item)"
				></el-cascader>
				<el-date-picker
					v-if="item.type === 'date'"
					v-model="dialog.form[item.name]"
					class="item1"
					type="datetime"
					:placeholder="item.placeholder"
					value-format="yyyy-MM-dd HH:mm:ss"
				></el-date-picker>
				<el-color-picker v-if="item.type === 'color'" v-model="dialog.form[item.name]" class="item1"></el-color-picker>
				<el-select
					v-if="item.type === 'select'"
					v-model="dialog.form[item.name]"
					class="item1"
					filterable
					clearable
					:multiple="item?.multiple ?? false"
					:placeholder="item.placeholder"
					@change="handleChange(item)"
				>
					<el-option v-for="i in item.options" :key="i.value" :label="i.label" :value="i.value"></el-option>
				</el-select>
				<el-select
					v-if="item.type === 'select_id'"
					v-model="dialog.form[item.name]"
					class="item1"
					filterable
					clearable
					:multiple="item?.multiple ?? false"
					:placeholder="item.placeholder"
					@change="handleChange(item)"
				>
					<el-option v-for="i in item.options" :key="i.id" :label="i.name" :value="i.id"></el-option>
				</el-select>
				<el-select
					v-if="item.type === 'select_s'"
					v-model="dialog.form[item.name]"
					class="item1"
					clearable
					:multiple="item?.multiple ?? false"
					:placeholder="item.placeholder"
					@change="handleChange(item)"
				>
					<el-option
						v-for="i in item.options"
						:key="i[item?.defaultProps.value ?? 'id']"
						:label="i[item?.defaultProps.label ?? 'label']"
						:value="i[item?.defaultProps.value ?? 'value']"
					></el-option>
				</el-select>
				<div v-if="item.type === 'form'" class="subItem" :style="`overflow-x: ${selece(item.name).config.length > 7 ? 'auto' : 'hidden'}`">
					<div class="subItem1">
						<div
							v-for="subItem in item.config"
							:key="subItem.name"
							class="subItem2"
							:style="`flex-grow: ${selece(item.name).config.length > 7 ? 0 : 1}`"
						>
							<div v-if="item?.showLabel ?? false" class="subItem3">
								<div style="flex-shrink: 0">{{ subItem.label }}</div>
							</div>
							<div v-for="(content, index) in dialog.form[item.name]" :key="index">
								<div v-if="subItem.type === 'input'" class="subItem4" style="position: relative" @click="handleClick(subItem, content)">
									<el-input
										v-model="content[subItem.name]"
										style="width: calc(100% - 10px)"
										:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
										@change="handleChange(subItem, content)"
									></el-input>
									<div
										v-if="subItem.disable !== undefined && subItem.disable(content)"
										style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 10; cursor: pointer"
									></div>
								</div>
								<div v-if="subItem.type === 'textarea'" class="subItem4">
									<el-input
										v-model="content[subItem.name]"
										style="width: calc(100% - 10px)"
										type="textarea"
										:rows="subItem?.rows ?? 2"
										:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
										@change="handleChange(subItem, content)"
									></el-input>
								</div>
								<div v-if="subItem.type === 'number'" class="subItem4">
									<el-input-number
										v-model="content[subItem.name]"
										style="width: calc(100% - 10px)"
										:min="subItem?.min ?? -Infinity"
										:max="subItem?.max ?? Infinity"
										:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
										@change="handleChange(subItem, content)"
									></el-input-number>
								</div>
								<div v-if="subItem.type === 'date'" class="subItem4">
									<el-date-picker
										v-model="content[subItem.name]"
										style="width: calc(100% - 10px)"
										type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss"
										:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
										@change="handleChange(subItem, content)"
									></el-date-picker>
								</div>
								<div v-if="subItem.type === 'switch'" class="subItem4">
									<el-switch
										v-model="content[subItem.name]"
										style="width: calc(100% - 10px)"
										:active-text="subItem?.options?.active?.text ?? ''"
										:inactive-text="subItem?.options?.inactive?.text ?? ''"
										:active-value="subItem?.options?.active?.value ?? ''"
										:inactive-value="subItem?.options?.inactive?.value ?? ''"
										:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
										@change="handleChange(subItem, content)"
									></el-switch>
								</div>
								<div v-if="subItem.type === 'checkbox'" class="subItem4">
									<el-checkbox
										v-model="content[subItem.name]"
										style="width: calc(100% - 10px)"
										:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
										@change="handleChange(subItem, content)"
									></el-checkbox>
								</div>
								<div v-if="subItem.type === 'select'" class="subItem4">
									<el-select
										v-model="content[subItem.name]"
										style="width: calc(100% - 10px)"
										clearable
										:multiple="subItem?.multiple ?? false"
										:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
										@change="handleChange(subItem, content)"
									>
										<el-option v-for="i in subItem.options" :key="i.value" :label="i.label" :value="i.value"></el-option>
									</el-select>
								</div>
								<div v-if="subItem.type === 'selectS'" class="subItem4">
									<el-select
										v-model="content[subItem.name]"
										style="width: calc(100% - 10px)"
										clearable
										:multiple="subItem?.multiple ?? false"
										:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
										@change="handleChange(subItem, content)"
									>
										<el-option
											v-for="i in content.name.includes('采集长度')
												? subItem.lengthOption
												: content.name.includes('采集间隔')
													? subItem.intervalOption
													: subItem.freqOption"
											:key="i.value"
											:label="i.label"
											:value="i.value"
										></el-option>
									</el-select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-form-item>
			<el-tabs v-if="dialog.group" v-model="activeName" type="card" style="width: 100%">
				<el-tab-pane v-for="tab in dialog.group" :key="tab" class="sel" :label="tab" :name="tab">
					<el-form-item
						v-for="item in dialog.config"
						v-show="(item.show !== undefined ? item.show() : true) && item.group && item.group === tab"
						:key="item.name"
						class="item"
						:prop="item.name"
						:label="item.label"
					>
						<el-input
							v-if="item.type === 'input'"
							v-model="dialog.form[item.name]"
							class="item1"
							:placeholder="item.placeholder"
							:disabled="item.disable === undefined ? false : item.disable()"
							@change="handleChange(item)"
						></el-input>
						<el-input
							v-if="item.type === 'textarea'"
							v-model="dialog.form[item.name]"
							class="item1"
							type="textarea"
							:rows="item?.rows ?? 2"
							:placeholder="item.placeholder"
							:disabled="item.disable === undefined ? false : item.disable()"
							@change="handleChange(item)"
						></el-input>
						<el-input-number
							v-if="item.type === 'number'"
							v-model="dialog.form[item.name]"
							class="item1"
							:min="item?.min ?? -Infinity"
							:max="item?.max ?? Infinity"
							:placeholder="item.placeholder"
						></el-input-number>
						<el-switch
							v-if="item.type === 'switch'"
							v-model="dialog.form[item.name]"
							class="item1"
							:active-text="item?.options?.active?.text ?? ''"
							:inactive-text="item?.options?.inactive?.text ?? ''"
							:active-value="item?.options?.active?.value ?? ''"
							:inactive-value="item?.options?.inactive?.value ?? ''"
							@change="handleChange(item)"
						></el-switch>
						<el-checkbox
							v-if="item.type === 'checkbox'"
							v-model="dialog.form[item.name]"
							class="item1"
							:disabled="item.disable === undefined ? false : item.disable()"
							@change="handleChange(item)"
						></el-checkbox>
						<el-cascader
							v-if="item.type === 'cascader'"
							v-model="dialog.form[item.name]"
							class="item1"
							:placeholder="item.placeholder"
							:options="item.options"
							:show-all-levels="item?.showAllLevels ?? false"
							:props="{ checkStrictly: item?.checkStrictly ?? true, multiple: item?.multiple ?? false }"
							clearable
							@change="handleChange(item)"
						></el-cascader>
						<el-date-picker
							v-if="item.type === 'date'"
							v-model="dialog.form[item.name]"
							class="item1"
							type="datetime"
							:placeholder="item.placeholder"
							value-format="yyyy-MM-dd HH:mm:ss"
						></el-date-picker>
						<el-color-picker v-if="item.type === 'color'" v-model="dialog.form[item.name]" class="item1"></el-color-picker>
						<el-select
							v-if="item.type === 'select'"
							v-model="dialog.form[item.name]"
							class="item1"
							filterable
							clearable
							:multiple="item?.multiple ?? false"
							:placeholder="item.placeholder"
							@change="handleChange(item)"
						>
							<el-option v-for="i in item.options" :key="i.value" :label="i.label" :value="i.value"></el-option>
						</el-select>
						<el-select
							v-if="item.type === 'select_id'"
							v-model="dialog.form[item.name]"
							class="item1"
							filterable
							clearable
							:multiple="item?.multiple ?? false"
							:placeholder="item.placeholder"
							@change="handleChange(item)"
						>
							<el-option v-for="i in item.options" :key="i.id" :label="i.name" :value="i.id"></el-option>
						</el-select>
						<el-select
							v-if="item.type === 'select_s'"
							v-model="dialog.form[item.name]"
							class="item1"
							clearable
							:multiple="item?.multiple ?? false"
							:placeholder="item.placeholder"
							@change="handleChange(item)"
						>
							<el-option
								v-for="i in item.options"
								:key="i[item?.defaultProps.value ?? 'id']"
								:label="i[item?.defaultProps.label ?? 'label']"
								:value="i[item?.defaultProps.value ?? 'value']"
							></el-option>
						</el-select>
						<div v-if="item.type === 'form'" class="subItem" :style="`overflow-x: ${selece(item.name).config.length > 3 ? 'auto' : 'hidden'}`">
							<div class="subItem1">
								<div
									v-for="subItem in item.config"
									:key="subItem.name"
									class="subItem2"
									:style="`flex-grow: ${selece(item.name).config.length > 3 ? 0 : 1}`"
								>
									<div v-if="item?.showLabel ?? false" class="subItem3">
										<div style="flex-shrink: 0">{{ subItem.label }}</div>
									</div>
									<div v-for="(content, index) in dialog.form[item.name]" :key="index">
										<div v-if="subItem.type === 'input'" class="subItem4">
											<el-input
												v-model="content[subItem.name]"
												style="width: calc(100% - 10px)"
												:disabled="subItem.disable === undefined ? false : subItem.disable()"
											></el-input>
										</div>
										<div v-if="subItem.type === 'textarea'" class="subItem4">
											<el-input
												v-model="content[subItem.name]"
												style="width: calc(100% - 10px)"
												type="textarea"
												:rows="subItem?.rows ?? 2"
												:disabled="subItem.disable === undefined ? false : subItem.disable()"
											></el-input>
										</div>
										<div v-if="subItem.type === 'number'" class="subItem4">
											<el-input-number
												v-model="content[subItem.name]"
												style="width: calc(100% - 10px)"
												:min="subItem?.min ?? -Infinity"
												:max="subItem?.max ?? Infinity"
											></el-input-number>
										</div>
										<div v-if="subItem.type === 'date'" class="subItem4">
											<el-date-picker
												v-model="content[subItem.name]"
												style="width: calc(100% - 10px)"
												type="datetime"
												value-format="yyyy-MM-dd HH:mm:ss"
											></el-date-picker>
										</div>
										<div v-if="subItem.type === 'switch'" class="subItem4">
											<el-switch
												v-model="content[subItem.name]"
												style="width: calc(100% - 10px)"
												:active-text="subItem?.options?.active?.text ?? ''"
												:inactive-text="subItem?.options?.inactive?.text ?? ''"
												:active-value="subItem?.options?.active?.value ?? ''"
												:inactive-value="subItem?.options?.inactive?.value ?? ''"
											></el-switch>
										</div>
										<div v-if="subItem.type === 'checkbox'" class="subItem4">
											<el-checkbox
												v-model="content[subItem.name]"
												style="width: calc(100% - 10px)"
												:disabled="subItem.disable === undefined ? false : subItem.disable(content)"
											></el-checkbox>
										</div>
										<div v-if="subItem.type === 'select'" class="subItem4">
											<el-select v-model="content[subItem.name]" style="width: calc(100% - 10px)" clearable :multiple="subItem?.multiple ?? false">
												<el-option v-for="i in subItem.options" :key="i.value" :label="i.label" :value="i.value"></el-option>
											</el-select>
										</div>
										<div v-if="subItem.type === 'selectS'" class="subItem4">
											<el-select v-model="content[subItem.name]" style="width: calc(100% - 10px)" clearable :multiple="subItem?.multiple ?? false">
												<el-option
													v-for="i in content.name.includes('采集长度')
														? subItem.lengthOption
														: content.name.includes('采集间隔')
															? subItem.intervalOption
															: subItem.freqOption"
													:key="i.value"
													:label="i.label"
													:value="i.value"
												></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-form-item>
				</el-tab-pane>
			</el-tabs>
			<el-form-item v-if="btnType != 'view'" style="width: 100%">
				<el-button v-if="isOk" type="primary" @click="onSubmit">{{ t('componentsModule.zyForm.confirm') }}</el-button>
				<el-button @click="isShow = false">{{ t('componentsModule.zyForm.cancel') }}</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script setup lang="ts" name="zyForm">
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
	width: {
		type: String,
		default() {
			return '50%'
		}
	},
	isOk: {
		type: Boolean,
		default() {
			return true
		}
	},
	dialog: {
		type: Object,
		default() {
			return {
				labelWidth: 'auto',
				config: [],
				form: {},
				title: ''
			}
		}
	}
})

const emit = defineEmits(['add', 'set'])
const dialog = reactive<any>(props.dialog)
const rules = reactive<any>({})
const isShow = ref(false)
const btnType = ref('')
const activeName = ref('')

const form = ref<any>(null)

const openDialog = (type: string) => {
	btnType.value = type
	dialog.config.forEach((item: any) => {
		if (item.onChange !== undefined) {
			item.onChange(dialog.config, dialog.form)
		}
		let rules = item.validators || []
		if (item.required) {
			rules.push({ required: true, message: t('componentsModule.zyForm.requiredField', { field: item.label }), trigger: 'blur' })
		}
		rules[item.name] = rules
	})
	if (dialog.group && dialog.group.length !== 0) {
		activeName.value = dialog.group[0]
	}
	isShow.value = true
}

const closeDialog = () => {
	isShow.value = false
}

const onSubmit = () => {
	form.value.validate((valid: boolean) => {
		if (valid) {
			if (btnType.value === 'add') {
				emit('add', dialog.form)
			} else {
				emit('set', dialog.form)
			}
		} else {
			ElMessage.error(t('componentsModule.zyForm.validationFailed'))
		}
	})
}

const handleClick = (item: any, row?: any) => {
	if (item.onClick !== undefined) {
		item.onClick(dialog.config, dialog.form, row)
	}
}

const handleChange = (item: any, row?: any) => {
	if (item.onChange !== undefined) {
		item.onChange(dialog.config, dialog.form, row)
	}
}

const selece = (name: string) => {
	return dialog.config.find((item: any) => item.name === name)
}

defineExpose({
	openDialog,
	closeDialog
})
</script>

<style lang="scss" scoped>
.zy {
	.text {
		height: 30px;
		line-height: 30px;
		font-size: 16px;
		color: #b2e3ff;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.border {
		border: 1px solid #007bff;
		border-radius: 4px;
		overflow-x: auto;
	}
	.item {
		width: 100%;

		// .item1 {
		// 	width: 90%;
		// }
	}

	.subItem {
		box-sizing: border-box;
		width: 100%;
		overflow-x: auto;
		// border: #dcdfe6 solid 1px;
		border-radius: 5px;
		.subItem1 {
			display: flex;
			flex-wrap: nowrap;
			.subItem2 {
				width: 150px;
				flex-grow: 0;
				flex-shrink: 0;
				.subItem3 {
					padding: 0 5px;
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					// border-left: #dcdfe6 solid 1px;
					// border-right: #dcdfe6 solid 1px;

					i {
						flex-shrink: 0;
						width: 10px !important;
						font-size: 16px;
						cursor: pointer;
					}
				}

				.subItem4 {
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					height: 40px;
					// border: #dcdfe6 solid 1px;
				}
			}
		}
	}
}

::v-deep(.el-form-item__label) {
	color: var(--deep-blue-text-primary) !important;
}
::v-deep(.el-tabs__item) {
	color: var(--deep-blue-text-primary);
}
::v-deep(.el-tabs__item.is-active) {
	color: var(--el-color-primary);
}
::v-deep(.el-tabs--card > .el-tabs__header .el-tabs__item) {
	border: none;
}
::v-deep(.el-tabs--card > .el-tabs__header .el-tabs__nav) {
	border: none;
}

::v-deep(.el-input-number) {
	width: 100%;
}
</style>
